module.exports = __webpack_public_path__ + "img/serve-country-03.785b21cb.png";